import { render } from "./Q1-Intro.vue?vue&type=template&id=175e3494&scoped=true"
import script from "./Q1-Intro.vue?vue&type=script&lang=js"
export * from "./Q1-Intro.vue?vue&type=script&lang=js"

import "./Q1-Intro.vue?vue&type=style&index=0&id=175e3494&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175e3494"]])

export default __exports__